import { render, staticRenderFns } from "./CollectionIssueLetterHistoryEditDialog.vue?vue&type=template&id=4a2b8766&"
import script from "./CollectionIssueLetterHistoryEditDialog.vue?vue&type=script&lang=ts&"
export * from "./CollectionIssueLetterHistoryEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports